"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    MIN_WIDTH: 320,
    MOBILE: 480,
    TABLET: 767,
    DESKTOP: 992,
    LARGE_DESKTOP: 1200,
    MAX_WIDTH: 1600,
};
